import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, groupBy, sortBy } from 'lodash';
import { List, ListItem, FlatButton, Dialog, TextField } from 'material-ui';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { compose } from 'recompose';
import { translate } from 'admin-on-rest';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { getPossibleReferences } from 'admin-on-rest/lib/reducer/admin/references/possibleValues';
// import equal from 'deep-equal';

import PriceInput from '../PriceInput';
import { getTranslationByLocale } from '../../../utils/TranslationUtils';
import { formatPrice } from '../../../utils/NumberUtils';
import { callApi } from '../../../client/apiToolbox';

import CheckboxAndInput from './CheckboxInput';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';

const referenceSource = (resource, source) => `${resource}@${source}`;

// const getMarket = (markets, id) => {
//   const market = markets.find((mrkt) => (
//     mrkt.marketId === id
//   ));
//   if (market) {
//     return market;
//   }
//   return null;
// };

// const stateChanged = (state, next) => (
//   state.openProduct !== next.openProduct
//   || state.choices.length !== next.choices.length
//   || state.price !== next.price
// );

export class CheckboxAndPriceInputComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLocked: false,
      choices: props.choices,
      isLoadingBigdata: false,
    };
  }

  // shouldComponentUpdate = (nextProps, nextState) => !equal(this.props, nextProps) || stateChanged(this.state, nextState)

  componentDidUpdate = (prevProps) => {
    if (this.props.choices.length !== prevProps.choices.length) {
      this.setState({
        choices: this.props.choices,
      });
    }
  };

  priceSubmit = () => {
    const {
      input: { value, onChange },
    } = this.props;
    const { price, openProduct } = this.state;
    const val = value.find((v) => v.product === openProduct.product);
    if (val) {
      val.price = parseInt(price, 10);
      onChange(value);
      this.setState({ openProduct: null });
    }
  };

  queryBigdata = (products) => {
    this.setState({ isLoadingBigdata: true });
    callApi(
      `${API_BASE_URL}/utils/bigdata`,
      'POST',
      { 'Content-Type': 'application/json', credentials: 'include' },
      {
        locale: this.props.locale,
        products,
      }
    )
      .then((data) =>
        this.setState({ bigdata: data.json, isLoadingBigdata: false }, () =>
          console.log(this.state.bigdata)
        )
      )
      .catch((e) => console.log('ERROR', e));
  };

  toggleLocked = () => this.setState({ showLocked: !this.state.showLocked });

  render() {
    const {
      input: { value },
      // eslint-disable-next-line no-shadow
      translate,
      // isRequired,
      optionValue,
      marketValue,
      locale,
      categories,
      promotions,
      user,
    } = this.props;
    const { choices } = this.state;
    const groupedChoices = groupBy(
      choices,
      (choice) =>
        choice.category && getTranslationByLocale(choice.category.title, locale)
    );

    if (!marketValue) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <h2>- Select a market first -</h2>
        </div>
      );
    }

    let confirmDisabled = false;
    if (user && user.superUser) {
      confirmDisabled = false;
    } else if (
      Number.isNaN(this.state.price) ||
      !this.state.price ||
      this.state.price < this.state.min ||
      this.state.price > this.state.max
    ) {
      confirmDisabled = true;
    }

    return (
      <div>
        <TextField
          floatingLabelText={translate('search', {
            queryables: `${translate('name')}, ${translate('categories')}`,
          })}
          onChange={(e) => {
            this.setState({
              choices: this.props.choices.filter((choice) =>
                e.target.value
                  ? new RegExp(e.target.value, 'gi').test(
                    // search for internalName
                    choice.internalName
                  ) ||
                    new RegExp(e.target.value, 'gi').test(
                      // or category name
                      getTranslationByLocale(choice.title, locale)
                    ) ||
                    new RegExp(e.target.value, 'gi').test(
                      // or category name
                      getTranslationByLocale(
                        choice.category && choice.category.title,
                        locale
                      )
                    )
                  : true
              ),
            });
          }}
        />
        <List>
          {choices.length > 0 &&
            categories.length > 0 &&
            sortBy(
              categories.filter((c) => c.promotion),
              'position'
            ).map((category) => {
              const items = promotions
                .filter((promotion) => promotion.category._id === category.id)
                .map((promotion) => (
                  <ListItem
                    key={promotion.product._id}
                    primaryText={promotion.product.internalName}
                  />
                ))
                .filter((item) => !!item);

              if (items.length > 0) {
                return (
                  <ListItem
                    key={category.id}
                    primaryTogglesNestedList
                    primaryText={getTranslationByLocale(category.title, locale)}
                    nestedItems={items}
                  />
                );
              }
              return null;
            })}
          {choices.length > 0 &&
            categories.length > 0 &&
            sortBy(
              categories.filter((c) => {
                const localMarket = c.markets
                  ? c.markets.map((market) => market._id === marketValue._id)
                  : [];
                const returnMarket =
                  localMarket.includes(true) || localMarket.length === 0
                    ? localMarket
                    : null;
                return !c.promotion && returnMarket;
              }),
              'position'
            ).map((category) => {
              const categoryName = getTranslationByLocale(
                category.title,
                locale
              );
              if (
                groupedChoices[categoryName] &&
                groupedChoices[categoryName].length > 0
              ) {
                return (
                  <ListItem
                    key={categoryName}
                    primaryTogglesNestedList
                    primaryText={<strong>{categoryName}</strong>}
                    // onClick={() => this.queryBigdata(groupedChoices[categoryName])}
                    nestedItems={sortBy(
                      groupedChoices[categoryName],
                      'position'
                    ).map((choice) => {
                      // const choiceMarket = marketValue ? getMarket(choice.markets, marketValue._id) : null;
                      const hydratedChoice =
                        value &&
                        value.find(
                          (v) => v.product === get(choice, optionValue)
                        );

                      if (!hydratedChoice && choice.frozen) {
                        return null;
                      }
                      // if (this.state.showLocked) {
                      //   return <CheckboxAndInput key={choice.code} selectProduct={(product, min, max, precision, currency) => this.setState({ openProduct: product, min, max, precision, currency })} choice={choice} choiceValue={hydratedChoice} {...this.props} />;
                      // }
                      // return (!choiceMarket || !choiceMarket.locked) && <CheckboxAndInput key={choice.code} selectProduct={(product, min, max, precision, currency) => this.setState({ openProduct: product, min, max, precision, currency })} choice={choice} choiceValue={hydratedChoice} {...this.props} />;
                      // return <pre>{JSON.stringify(value, null, 2)}</pre>;
                      return (
                        <CheckboxAndInput
                          {...this.props}
                          {...this.state}
                          bigdata={
                            this.state.bigdata
                              ? this.state.bigdata.find(
                                (item) =>
                                  item.product ===
                                    getTranslationByLocale(choice.title, locale)
                              )
                              : null
                          }
                          venues={
                            this.state.bigdata && this.state.bigdata.venues
                              ? this.state.bigdata.venues.length
                              : 0
                          }
                          key={choice.code}
                          selectProduct={(
                            product,
                            min,
                            max,
                            precision,
                            currency
                          ) =>
                            this.setState({
                              openProduct: product,
                              min,
                              max,
                              precision,
                              currency,
                            })
                          }
                          choice={choice}
                          choiceValue={hydratedChoice}
                          isLoadingBigdata={this.state.isLoadingBigdata}
                        />
                      );
                    })}
                  />
                );
              }
              return null;
            })}
        </List>
        <Dialog
          contentStyle={{ width: '400px' }}
          bodyStyle={{ display: 'flex', flexDirection: 'row' }}
          autoScrollBodyContent
          open={this.state.openProduct}
          onRequestClose={() => this.setState({ openProduct: null })}
          actions={[
            <FlatButton
              label="Cancel"
              onClick={() => this.setState({ openProduct: null })}
            />,
            <FlatButton
              disabled={confirmDisabled}
              label="Confirm"
              onClick={() => this.priceSubmit()}
            />,
          ]}
        >
          <PriceInput
            label="Price"
            errorText={
              this.state.price !== '' &&
              (this.state.price < this.state.min ||
                this.state.price > this.state.max)
                ? translate('valueNotInRange')
                : `${formatPrice(
                  this.state.min,
                  this.state.precision,
                  this.state.currency
                )} - ${formatPrice(
                  this.state.max,
                  this.state.precision,
                  this.state.currency
                )}`
            }
            errorStyle={
              this.state.price !== '' &&
              (this.state.price < this.state.min ||
                this.state.price > this.state.max)
                ? { color: 'rgb(183, 28, 28)' }
                : { color: 'darkslategrey' }
            }
            style={{ flex: '0 1 50%' }}
            precision={this.state.precision}
            currencyCode={this.state.currency}
            input={{
              value: this.state.price,
              onChange: (price) => this.setState({ price }),
            }}
          />
        </Dialog>
      </div>
    );
  }
}

CheckboxAndPriceInputComponent.propTypes = {
  addField: PropTypes.bool,
  choices: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  source: PropTypes.string,
  options: PropTypes.object,
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
  }),
  isRequired: PropTypes.bool,
  optionText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element,
  ]),
  optionValue: PropTypes.string,
  resource: PropTypes.string,
  translate: PropTypes.func.isRequired,
  translateChoice: PropTypes.bool,
  muiTheme: PropTypes.object.isRequired,
  categories: PropTypes.array,
};

CheckboxAndPriceInputComponent.defaultProps = {
  addField: true,
  choices: [],
  options: {},
  optionText: 'name',
  optionValue: 'id',
  translateChoice: true,
};

const enhance = compose(translate, muiThemeable());

const CheckboxAndPriceInput = enhance(CheckboxAndPriceInputComponent);

const selector = formValueSelector('record-form');

CheckboxAndPriceInput.propTypes = {
  addField: PropTypes.bool.isRequired,
};

CheckboxAndPriceInput.defaultProps = {
  addField: true,
};

function mapStateToProps(state, props) {
  return {
    location: state,
    marketValue: selector(state, 'market'),
    name: selector(state, 'name'),
    promotions: getPossibleReferences(
      state,
      referenceSource(props.resource, 'promoted-products'),
      'promoted-products'
    ),
    categories: getPossibleReferences(
      state,
      referenceSource(props.resource, 'categories'),
      'categories'
    ),
  };
}

export default connect(mapStateToProps)(CheckboxAndPriceInput);
